import { Stack, Typography } from '@mui/material'
import { IInvestmentOrder } from '~/@api/generated-api-types/global.types'
import { Graph } from '~/@biz_investor/investment/Summary/Graph'
import { GraphSummaryChildren } from '~/@biz_investor/opportunity-detail/GraphSummaryChildren'
import { GraphSummaryPension } from '~/@biz_investor/opportunity-detail/GraphSummaryPension'
import ExclamationBuble from '~/@ui/_sharedSvgs/ui/ExclamationBuble.svg?react'
import { calculateInvestmentProjections } from '~/@ui/chart/_utils/investmentCalculator'

type Props = {
  investment: IInvestmentOrder | null
  series: ReturnType<typeof calculateInvestmentProjections>
}

export const Summary = ({ investment, series }: Props) => {
  const isSavingsChildren =
    investment?.productSnapshot.slug === 'buducnost-mojich-deti'
  const isSavingsRetirement =
    investment?.productSnapshot.slug === 'zabezpecenie-financii-na-dochodok'
  // const isSavingsBeatInflation =
  //   investment?.productSnapshot.slug === 'sporte-a-porazte-inflaciu'

  return (
    <Stack className="bg-zBlack200">
      <Stack className="divide-y border-t border-zBlack250 divide-zBlack250">
        <Stack className="flex-row h-[51px] justify-between items-center px-6">
          <Stack className="flex-row gap-2">
            <Typography className="text-3d font-medium text-zGrey450">
              Aktuálne výnos
            </Typography>
            <ExclamationBuble className="w-6 h-6" />
          </Stack>
          <Stack className="flex-row">
            <Typography
              className="text-base/[24px] font-black text-zGreen500"
              style={{ textShadow: '0px 4px 10px #45F55A66' }}>
              ---
            </Typography>
          </Stack>
        </Stack>
        <Stack className="flex-row h-[48px] justify-between items-center px-6 py-4">
          <Stack className="flex-row gap-2">
            <Typography className="text-3d font-medium text-zGrey450">
              Mesačná investícia
            </Typography>
            <ExclamationBuble className="w-6 h-6" />
          </Stack>
          <Typography className="text-base font-bold text-zWhite250 tabular-nums">
            {investment?.monthlyInvestmentAmount
              ? `${Math.floor(investment.monthlyInvestmentAmount).toLocaleString('sk-Sk')} €`
              : '... €'}
          </Typography>
        </Stack>
        <Stack className="flex-row h-[48px] justify-between items-center px-6 py-4">
          <Stack className="flex-row gap-2">
            <Typography className="text-3d font-medium text-zGrey450">
              Investované
            </Typography>
            <ExclamationBuble className="w-6 h-6" />
          </Stack>
          <Typography className="text-base font-bold text-zWhite250 tabular-nums">
            {typeof investment?.totalInvestedAmount === 'number'
              ? `${Math.floor(investment.totalInvestedAmount).toLocaleString('sk-Sk')} €`
              : '... €'}
          </Typography>
        </Stack>
        <Stack className="flex-row h-[48px] justify-between items-center px-6 py-4">
          <Stack className="flex-row gap-2">
            <Typography className="text-3d font-medium text-zGrey450">
              Hodnota investície
            </Typography>
            <ExclamationBuble className="w-6 h-6" />
          </Stack>
          <Typography className="text-base font-bold text-zWhite250 tabular-nums">
            {typeof investment?.totalReturnedAmount === 'number'
              ? `${Math.floor(investment.totalReturnedAmount).toLocaleString('sk-Sk')} €`
              : '... €'}
          </Typography>
        </Stack>
        <Stack className="flex-row h-[48px] justify-between items-center px-6 py-4">
          <Stack className="flex-row gap-2">
            <Typography className="text-3d font-medium text-zGrey450">
              Začiatok investície
            </Typography>
            <ExclamationBuble className="w-6 h-6" />
          </Stack>
          <Typography className="text-base font-bold text-zWhite250">
            ---
          </Typography>
        </Stack>
      </Stack>
      <Stack className="gap-3 px-6 mt-6">
        <Graph series={series} slug={investment?.productSnapshot.slug || ''} />

        {isSavingsChildren && (
          <GraphSummaryChildren
            years18={Math.round(series.bonashipValue[216] || 0).toLocaleString(
              'sk-SK'
            )}
            years25={Math.round(series.bonashipValue[300] || 0).toLocaleString(
              'sk-SK'
            )}
            years30={Math.round(series.bonashipValue[360] || 0).toLocaleString(
              'sk-SK'
            )}
            interestPerAnnum={Math.floor(series.rates.bonaship * 10000) * 0.01}
          />
        )}

        {isSavingsRetirement && <GraphSummaryPension series={series} />}
      </Stack>
    </Stack>
  )
}
